type TripLegException = {
  tripLegExceptionID: number;
  tripLegExceptionBC: string;
  tripLegExceptionName: string;
  tripLegDescription: string;
  isActive: boolean;
  createdOnUTC: string;
  createdByUserID: number;
  modifiedOnUTC: string;
  modifiedByUserID: number;
};

enum TripLegExceptionBC {
  ReadyInvoice = 'READYINVOICE',
  NoDriver = 'NODRIVER',
  DriverNotOnline = 'DRIVERNOTONLINE',
  DriverLate = 'DRIVERLATE',
}

const needsAttentionExceptionList: TripLegExceptionBC[] = [
  TripLegExceptionBC.ReadyInvoice,
];

export {
  needsAttentionExceptionList,
  type TripLegException,
  TripLegExceptionBC,
};
